import { useCallback, useRef } from 'react';

import type { ApiRecipe } from '../../../../models/recipe/recipeModel';
import { RecipeModalTab } from '../../../recipe/models';
import { ga4CartTracking } from '../../tracking/ga4/cart';
import type { ModifyCartAnalyticsOptions } from '../../tracking/ga4/cart/ga4CartEvents';
import tracking from '../../tracking/tracking';

export const useBuyableRecipeFlyInTracking = () => {
    const modalPopupSent = useRef(false);

    const trackModalPopup = useCallback((recipe: ApiRecipe, portions: number) => {
        if (!modalPopupSent.current) {
            tracking.ecommerce.recipes.modalPopup(recipe, RecipeModalTab.Products, portions);
            modalPopupSent.current = true;
        }
    }, []);

    const trackAddToCart = useCallback(
        (
            products: { quantity: number; productId: string; variantId?: string; index?: number }[],
            storeId: string,
            listOptions: ModifyCartAnalyticsOptions,
        ) => {
            ga4CartTracking.modifyCartItems(
                products.map((item) => ({
                    index: item.index,
                    productId: item.productId,
                    previousQuantity: 0,
                    newQuantity: item.quantity,
                    variantId: item.variantId,
                })),
                storeId,
                listOptions,
            );
        },
        [],
    );

    return {
        trackModalPopup,
        trackBuyRecipe: tracking.ecommerce.recipes.buyRecipe,
        trackCalculationChange: tracking.ecommerce.recipes.calculationChange,
        trackPortionChange: tracking.ecommerce.recipes.portionChange,
        trackLinkClick: tracking.ecommerce.recipes.linkClick,
        trackSubstituteProduct: tracking.ecommerce.recipes.substituteProduct,
        trackAddToCart,
    };
};
